import { h } from "preact";

function IconSketch() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#iu8ovnmn3a)" fill-rule="evenodd" clip-rule="evenodd">
                <path d="M3.24 6.113 8 15.34 0 6.113h3.24zM12.76 6.113 8 15.34l8-9.226h-3.24z" fill="#EA6C00"/>
                <path d="M3.24 6.113h9.519l-4.76 9.226L3.24 6.113z" fill="#FDAD00"/>
                <path d="m8 1-4.51.472-.25 4.641L8 1zM8 1l4.508.472.25 4.641L8 1z" fill="#FDD231"/>
                <path d="m16 6.113-3.49-4.641.25 4.641H16zM0 6.113l3.49-4.641-.25 4.641H0z" fill="#FDAD00"/>
                <path d="M8 1 3.24 6.113h9.519L7.999 1z" fill="#FEEEB7"/>
            </g>
            <defs>
                <clipPath id="iu8ovnmn3a">
                    <path fill="#fff" d="M0 0h16v16H0z"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default IconSketch;
